import { render, staticRenderFns } from "./EditReport.vue?vue&type=template&id=d48ba910&"
import script from "./EditReport.vue?vue&type=script&lang=ts&"
export * from "./EditReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports